<template>
  <v-navigation-drawer app v-model="drawer"> 
    <template v-slot:prepend>
        <div class="d-flex align-center pa-3" >
            <div class="d-flex align-center justify-center" style="min-height: 40px; width: 100%">
                <h3 class="text-h6 font-weight-black ma-0">SOURCE</h3>
            </div>
        </div>
    </template>
    <div style="width: 100%; height: 100%; display: flex; flex-direction: column;">
        <v-divider/>
        <div class="px-4">
            <Menu :menu-list="menu"/>
        </div>
        <div class="mt-auto">
            <div class="px-4">
                <ColorMode/>
            </div>
            <Account/>
        </div>
    </div>
  </v-navigation-drawer>
</template>
<script>
import Menu from '@components/layout/components/menu';
import ColorMode from '@components/layout/components/colormode';
import Account from '@components/layout/components/account';

export default {
    components: {
      Menu,
      Account,
      ColorMode
    },
    data: function () {
        return {
            drawer: !this.$vuetify.breakpoint.mobile,
        }
    },
    computed: {
        user: function () {
            return this.$store.getters['persist/auth/user'];
        },
        menu: function () {
            return this.$store.getters['ui/menu/get'](this.user.domain.slug);
        },
        storeDrawer: function () {
            return this.$store.getters['ui/menu/getDrawer'];
        }
    },
    created: function () {
        this.$store.dispatch('ui/menu/setDrawer', !this.$vuetify.breakpoint.mobile);
    },
    watch: {
        storeDrawer: function () {
            this.drawer = this.storeDrawer;
        },
        drawer: function () {
            if (!this.$lodash.isEqual(this.drawer, this.storeDrawer)) {
                this.$store.dispatch('ui/menu/setDrawer', this.drawer);
            }
        }
    }
}
</script>